export default function isValidCoupon(expiryDateTimeStamp, nowDateTimeStamp) {
    // A coupon is considered valid if it hasn't expired
    return new Date(expiryDateTimeStamp) > new Date(nowDateTimeStamp);
}
//# sourceMappingURL=isValidCoupon.js.map